import { gql, useMutation } from '@apollo/client'
import { map, pick } from 'ramda'
import { useTranslation } from 'react-i18next'
import { useNotification } from '@btime/react-messager'

import { accountsClient } from '../../../../../utils/apollo/api'

const MUTATION = gql`
  mutation UpsertPermissions($inputs: [PermissionInput]) {
    upsertPermissions(inputs: $inputs) {
      id
    }
  }
`

const cleanRequest = map(pick(['name', 'profileId', 'enabled']))

export const useSavePermissions = onError => {
  const { t } = useTranslation('editPermissions')
  const notify = useNotification()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Permissions'], client: accountsClient })

  const handleRequest = form => {
    const inputs = cleanRequest(form)

    return request({ variables: { inputs } }).then(resp => {
      if (!!resp.errors) {
        notify.error({ title: t('errorUpdatingPermission') })
        if (onError) onError()
      }
    })
  }

  return [handleRequest, state]
}
